import { DynamicField } from "./dynamic-field.model";

export class DynamicChips<T> extends DynamicField<T> {

    max?: number;
    allowDuplicate?: boolean;
    showClear?: boolean;

    constructor(source: Partial<DynamicChips<T>>) {
        super();
        Object.assign(this, source);

        this.hiddenObserver?.subscribe(value => {
            this.hidden = value;
        });
    }
}